<main class="flex w-full flex-auto flex-col">
    <div class="mx-8 flex max-w-screen flex-wrap py-6">
        <div class="flex w-full items-center justify-between">
            <div>
                <h2 class="text-3xl font-semibold leading-8 tracking-tight">
                    Métricas de Produtos
                </h2>
            </div>
        </div>
    </div>

    <fuse-card class="mat-elevation-z8 mx-8 my-5 block">
        <div class="p-6">
            <div
                class="flex flex-col sm:flex-row items-center justify-between w-full space-y-4 sm:space-y-0 sm:space-x-4">
                <!-- Search -->
                <mat-form-field class="fuse-mat-no-subscript fuse-mat-dense w-full sm:w-80" [appearance]="'outline'">
                    <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                    <input matInput [placeholder]="'Buscar produto...'" [(ngModel)]="searchParams.q"
                        (input)="onSearch($event.target.value)" [autocomplete]="'off'">
                    <button *ngIf="searchParams.q" matSuffix mat-icon-button aria-label="Limpar"
                        (click)="searchParams.q = ''; onSearch('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
                    <!-- Category Filter -->
                    <mat-form-field class="fuse-mat-no-subscript fuse-mat-dense w-full sm:w-60"
                        [appearance]="'outline'">
                        <mat-select [placeholder]="'Categorias'" [multiple]="true" [(value)]="searchParams.categories"
                            (selectionChange)="onCategoriesChange($event)">
                            <mat-option *ngFor="let cat of categories" [value]="cat.id">{{cat.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- Status Filter -->
                    <mat-form-field class="fuse-mat-no-subscript fuse-mat-dense w-full sm:w-40"
                        [appearance]="'outline'">
                        <mat-select [value]="searchParams.status || 'ALL'"
                            (selectionChange)="onStatusChange($event.value)">
                            <mat-option [value]="'ALL'">Todos</mat-option>
                            <mat-option [value]="'ACTIVE'">Ativo</mat-option>
                            <mat-option [value]="'BLOCKED'">Bloqueado</mat-option>
                            <mat-option [value]="'PAUSED'">Pausado</mat-option>
                            <mat-option [value]="'SOLD'">Vendido</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- Clear Filters -->
                    <button mat-stroked-button (click)="clearFilters()"
                        [disabled]="!searchParams.q && !searchParams.status && (!searchParams.categories || searchParams.categories.length === 0)">
                        Limpar Filtros
                    </button>
                </div>
            </div>
        </div>

        <div class="overflow-y-auto">
            <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">

                <!-- Name -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Produto</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="flex items-center gap-2">
                            <span class="font-medium">{{ row.name }}</span>
                            @if (row.duplicateAlert) {
                                <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 icon-size-4" matTooltip="Possível Duplicidade"></mat-icon>
                            }
                        </div>
                    </td>
                </ng-container>

                <!-- Category -->
                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>Categoria</th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.category }}
                    </td>
                </ng-container>

                <!-- Price -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Preço</th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.price | currency:'BRL' }}
                    </td>
                </ng-container>

                <!-- Seller Badge -->
                <ng-container matColumnDef="sellerBadge">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Selo Vendedor</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <ng-container *ngIf="row.sellerBadge && row.sellerBadge !== 'Nenhum'; else noBadge">
                            <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide border"
                                [ngClass]="{
                                    'bg-orange-50 text-orange-600 border-orange-200 dark:bg-orange-500/10 dark:text-orange-400 dark:border-orange-500/20': row.sellerBadge === 'Ouro',
                                    'bg-slate-50 text-slate-600 border-slate-200 dark:bg-slate-500/10 dark:text-slate-400 dark:border-slate-500/20': row.sellerBadge === 'Prata',
                                    'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/20': row.sellerBadge === 'Bronze'
                                }">
                                {{ row.sellerBadge }}
                            </span>
                        </ng-container>
                        <ng-template #noBadge>
                            <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium uppercase tracking-wide bg-gray-100/50 text-gray-400 border border-gray-200 dark:bg-gray-800/50 dark:text-gray-500 dark:border-gray-700">
                                Nenhum
                            </span>
                        </ng-template>
                    </td>
                </ng-container>

                <!-- Views -->
                <ng-container matColumnDef="views">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Vis.</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{ row.views }}
                    </td>
                </ng-container>

                <!-- Chats Started -->
                <ng-container matColumnDef="chatsStarted">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Chats</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{ row.chatsStarted }}
                    </td>
                </ng-container>

                <!-- Created At -->
                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Criado em</th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.createdAt | date:'short' }}
                    </td>
                </ng-container>

                <!-- Status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Status</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <span class="inline-flex rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide"
                            [ngClass]="{
                                'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50': row.status === 'ACTIVE',
                                'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': row.status === 'BLOCKED',
                                'bg-yellow-200 text-yellow-800 dark:bg-yellow-600 dark:text-yellow-50': row.status === 'PAUSED',
                                'bg-gray-200 text-gray-800 dark:bg-gray-600 dark:text-gray-50': row.status === 'SOLD'
                            }">
                            {{ row.status }}
                        </span>
                    </td>
                </ng-container>

                <!-- Action -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openAuditLog(row)">
                                <mat-icon>history</mat-icon>
                                <span>Ver Histórico de Ações</span>
                            </button>
                            <!-- TODO: View logica de detalhes -->
                            <!-- <button mat-menu-item (click)="viewDetails(row)">
                                <mat-icon>visibility</mat-icon>
                                <span>Ver Detalhes</span>
                            </button> -->
                            <button mat-menu-item (click)="toggleStatus(row)"
                                *ngIf="!permissionService.can('block_product')">
                                <mat-icon>{{ row.status === 'BLOCKED' ? 'check_circle' : 'block' }}</mat-icon>
                                <span>{{ row.status === 'BLOCKED' ? 'Desbloquear' : 'Bloquear' }}</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <mat-paginator class="w-full" [length]="totalAmount" [pageSize]="searchParams.size"
                [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons (page)="handlePageEvent($event)">
            </mat-paginator>
        </div>
    </fuse-card>
</main>